export default (checkbox, gridAPI) => {
    const parent = checkbox.closest('.ag-header-cell');

    // Retrieve the name of the current column.
    const currentColId = parent.getAttribute('col-id');
    // Obtain the indexes of rows in the table.
    const pageSize = gridAPI.paginationGetPageSize();
    const currentPage = gridAPI.paginationGetCurrentPage();
    const rowStartIndex = currentPage * pageSize;
    const rowEndIndex = rowStartIndex + pageSize - 1;
    // Retrieve the current cell ranges.
    const cellRanges = gridAPI.getCellRanges();
    // Store the IDs of the active columns.
    let colsActive = [];

    // Iterate through all ranges and verify if any of them are from the "select-all" option.
    cellRanges.forEach(function (item) {
        const iteRowStartIndex = item.startRow.rowIndex;
        const iteRowEndIndex = item.endRow.rowIndex;
        // A range is considered to be from "select-all" if all rows are selected.
        if (
            rowStartIndex === iteRowStartIndex &&
            rowEndIndex === iteRowEndIndex
        ) {
            item.columns.forEach((column) => {
                if (!colsActive.includes(column.colId)) {
                    // Store the column ID of the "select-all" range.
                    colsActive.push(column.colId);
                }
            });
        }
    });

    // Include the current columnId if the checkbox is checked.
    // Exclude the current columnId if the checkbox is unchecked.
    if (checkbox.checked) {
        colsActive.push(currentColId);
    } else {
        const index = colsActive.indexOf(currentColId);
        if (index > -1) {
            colsActive.splice(index, 1);
        }
    }

    // Clear all selections.
    gridAPI.deselectAll();
    // Clear the range selection.
    gridAPI.clearRangeSelection();

    // Retrieve the cell ranges based on the Column ID.
    colsActive.forEach((column) => {
        gridAPI.addCellRange({
            rowStartIndex: 0,
            rowEndIndex: rowEndIndex,
            columns: [column],
        });
    });

    // Re-activate the "select-all" checkboxes.
    const headerCells = document.querySelectorAll('.ag-header-cell[col-id]');
    headerCells.forEach((item) => {
        const colId = item.getAttribute('col-id');
        if (colsActive.includes(colId)) {
            const checkboxWrapper = item.querySelector('.ag-input-wrapper');
            const input = checkboxWrapper.querySelector('.ag-checkbox-input');
            checkboxWrapper.classList.add('ag-checked');
            input.checked = true;
        }
    });
};
